<template>
  <div>
    <!--search form-->
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
    >
      <el-form-item label="用户名/手机号">
        <el-input v-model="searchForm.keyword" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="searchForm.orderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="searchForm.status" clearable filterable>
          <el-option
            v-for="item in orderStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付状态">
        <el-select v-model="searchForm.payStatus" clearable filterable>
          <el-option
            v-for="item in payStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付方式">
        <el-select v-model="searchForm.payway" clearable filterable>
          <el-option
            v-for="item in paywayOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付单号">
        <el-input v-model="searchForm.payOrderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="支付流水号">
        <el-input v-model="searchForm.paySerialNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="支付时间">
        <el-date-picker
          v-model="searchForm.beginPayTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.endPayTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="searchForm.beginCreateTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.endCreateTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
    </el-form>

    <!--buttons-->
    <div style="margin-bottom: 10px" class="table-btns">
      <div class="rl">
        <el-button size="mini" @click="handleGotoOrderRefund"
          >退款申请单</el-button
        >
      </div>
      <div class="rl">
        <el-button size="mini" @click="downLoad.exportExcel('tableId')"
          >导出</el-button
        >
      </div>
    </div>

    <!--table-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
      id="tableId"
      :key="tableKey"
    >
      <el-table-column prop="orderNo" label="订单号" align="center">
      </el-table-column>
      <el-table-column prop="goods" label="商品" align="center">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            type="primary"
            @click="handleGoods(scope.row)"
            >{{
              `${scope.row.goods.giftCardNo || ""}/${scope.row.goods
                .giftCardName || ""}`
            }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="goods.giftCardAmount"
        label="商品金额"
        align="center"
      ></el-table-column>
      <el-table-column prop="subscriber" label="用户" align="center">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            type="primary"
            @click="handleSubscriber(scope.row)"
            >{{
              `${scope.row.subscriber.subscriberName || ""}/${scope.row
                .subscriber.subscriberPhone || ""}`
            }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="orderStatus" label="订单状态" align="center">
        <template slot-scope="scope">
          {{ orderStatusMap[scope.row.orderStatus] }}
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="总金额" align="center">
      </el-table-column>
      <el-table-column prop="payStatus" label="支付状态" align="center">
        <template slot-scope="scope">
          {{ payStatusMap[scope.row.payStatus] }}
        </template>
      </el-table-column>
      <el-table-column prop="payAmount" label="支付金额" align="center">
      </el-table-column>
      <el-table-column prop="payway" label="支付方式" align="center">
        <template slot-scope="scope">
          {{ paywayMap[scope.row.payway] }}
        </template>
      </el-table-column>
      <el-table-column prop="payOrderNo" label="支付单号" align="center">
      </el-table-column>
      <el-table-column prop="paySerialNo" label="支付流水号" align="center">
      </el-table-column>
      <el-table-column prop="payTime" label="支付时间" align="center">
      </el-table-column>
      <el-table-column prop="created" label="创建时间" align="center">
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { loadOrderPage } from "@/api/giftCard";
export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      orderStatusOptions: [
        { label: "待支付", value: 1 },
        { label: "已完成", value: 2 },
        { label: "已取消", value: 3 },
        { label: "已退款", value: 4 },
        { label: "已关闭", value: 5 },
        { label: "退款中", value: 6 }
      ],
      orderStatusMap: {
        1: "待支付",
        2: "已完成",
        3: "已取消",
        4: "已退款",
        5: "已关闭",
        6: "退款中"
      },
      payStatusOptions: [
        { label: "未支付", value: "W" },
        { label: "已支付", value: "Y" }
      ],
      payStatusMap: {
        W: "未支付",
        Y: "已支付"
      },
      paywayOptions: [
        { label: "支付宝", value: "1" },
        { label: "现金", value: "2" },
        { label: "微信", value: "3" },
        { label: "支付宝-原生", value: "201" },
        { label: "微信-原生", value: "202" }
      ],
      paywayMap: {
        "1": "支付宝",
        "2": "现金",
        "3": "微信",
        "201": "支付宝-原生",
        "202": "微信-原生"
      },
      loading: false,
      tableData: []
    };
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    handleGoods(row) {
      this.$router.push({
        path: "/bizGiftCardRecord",
        query: {
          id: row.goods.giftCardSepId
        }
      });
    },
    handleSubscriber(row) {
      this.$router.push({
        path: "/subscriberDetail",
        query: {
          id: row.subscriber.subscriberId
        }
      });
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.searchForm.specId = this.giftCardSpecId;
      this.loading = true;
      loadOrderPage(this.searchForm)
        .then(res => {
          this.loading = false;
          if (res.data.status == 100) {
            this.searchForm.total = res.data.results.total;
            this.tableData = res.data.results.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    handleGotoOrderRefund() {
      this.$router.push({
        path: "/bizGiftCardOrderRefund"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-btns {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .rl {
    display: flex;
    align-items: center;
  }
  .btn {
    margin-left: 10px;
  }
  .rl {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// order.vue?43cb3e36